<template lang="pug">
.gu24-cor-btn(:class="{ 'gu24-cor-btn_active': active }", @click="click")
  span
    slot {{ name }}
</template>

<script>
export default {
  name: 'CorBtn',
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">

</style>
